import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { GPSProvider } from './contexts/GPSContext';
import App from './App';
import './index.css';

// Initialize Firebase before rendering
import { initializeFirebase } from './lib/firebase/init';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = createRoot(rootElement);

// Initialize Firebase and then render the app
initializeFirebase().then(() => {
  root.render(
    <StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <GPSProvider>
              <App />
            </GPSProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </StrictMode>
  );
}).catch(error => {
  console.error('Failed to initialize app:', error);
  root.render(
    <div className="p-8 text-center">
      <h1 className="text-2xl font-bold text-red-600 mb-4">Error</h1>
      <p className="text-gray-700">Failed to initialize application. Please try refreshing the page.</p>
    </div>
  );
});